import JerseyMessage from './JerseyMessage';

export default JerseyMessage;
